let dropdownLoaded = false
class HeaderDropdown extends HTMLElement {
  constructor() {
    super()

    this._input = document.querySelector('[data-search-overlay-el="input"]')
    this._animatedTextEls = document.querySelectorAll('[data-search-overlay-el="animatedText"]')
    this._mobileNavTrigger = document.querySelector('[data-search-overlay-el="mobileNavTrigger"]')
    this._mobileNav = document.querySelector('[data-search-overlay-el="mobileNav"]')

    this.setupListeners()

    const checkWindowBAO = setInterval(() => {
      if (window.BAO) {
        clearInterval(checkWindowBAO);

        this.renderDropdowns()
      }
    }, 100);
  }

  renderDropdowns () {
    if (dropdownLoaded) return

    const sectionRenderer = new window.BAO.BaoSectionRenderer()

    sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=dropdown`,
      )
      .then((res) => {
        dropdownLoaded = true

        const newDOM = sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )

        const myself = newDOM.querySelector(this.localName)
        this.outerHTML = myself.outerHTML

        const customEvent = new CustomEvent('headerDropdown:rendered')
        window.dispatchEvent(customEvent)
      })
      .catch(() => {})
  }

  setupListeners () {
    if (document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')) {
      document.addEventListener(
        'click',
        this.handleToggleButtonClick.bind(this),
      )
    }

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    this.addEventListener('pointermove', this.onPointerMove)
    this.addEventListener('mouseleave', this.onMouseLeave)
    this.addEventListener('focusin', this.handleFocusIn.bind(this))
    document.addEventListener('keyup', this.handleEscapePress.bind(this))

    this._input.addEventListener('input', (event) => {
      const query = event.target.value

      this._animatedTextEls.forEach(el => {
        el.setAttribute('aria-hidden', query.length > 0)
      });
    })

    this._mobileNavTrigger.addEventListener('click', () => {
      this._mobileNav.classList.add('open')
      document.body.classList.add('fixed')
    })
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (!this.els?.['menu-dropdown-toggle']?.exists) return

    if (!event.target.closest(this.els?.['menu-dropdown-toggle'].selector)) {
      return
    }

    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)

    if (!parentItemEl) return
    const menuDropdownEl = window.BAO?.Utils.getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })

    if (!menuDropdownEl) return

    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')

      this.setBackdrop(0)
    } else {
      menuToggleEl.setAttribute('data-active', 'true')
      menuDropdownEl.setAttribute('aria-expanded', 'true')

      document.dispatchEvent(new CustomEvent('dropdown:open'))
      this.setBackdrop(menuDropdownEl.offsetHeight)
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return

    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    const menuTrigers = this.querySelectorAll('[data-header-dropdown-el="trigger"]')
    const menuDropdownToggles = this.querySelectorAll('[data-header-dropdown-el="menu-dropdown-toggle"]')
    const menuDropdowns = this.querySelectorAll('[data-header-dropdown-el="menu-dropdown"]')

    if (menuTrigers.length) {
      menuTrigers.forEach((item) => {
        item.removeAttribute('open')
      })
    }

    if (menuDropdownToggles.length) {
      menuDropdownToggles.forEach((item) => {
        item.removeAttribute('data-active')
      })
    }

    if (menuDropdowns.length) {
      menuDropdowns.forEach((item) => {
        item.removeAttribute('aria-expanded');
      })
    }

    this.setBackdrop(0)
  }

  onPointerMove (event) {
    const activeTrigger = event.target.closest(
      '[data-header-dropdown-el="trigger"]',
    )
    const activeDropdown = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown"]',
    )

    if (!activeTrigger && !activeDropdown) {
      this.closeDropdowns()
      return
    }

    if (activeTrigger) {
      const matchedDropdown = this.querySelector(
        `[data-header-dropdown-el="menu-dropdown"]#${activeTrigger.dataset.id}`,
      )

      if (matchedDropdown) {
        activeTrigger.setAttribute('open', 'true')
        matchedDropdown.setAttribute('aria-expanded', 'true')

        this.querySelectorAll(
          '[data-header-dropdown-el="menu-dropdown"]',
        ).forEach((menuDropdownEl) => {
          if (matchedDropdown !== menuDropdownEl) {
            menuDropdownEl.removeAttribute('aria-expanded')
          }
        })

        document.dispatchEvent(new CustomEvent('dropdown:open'))

        this.setBackdrop(matchedDropdown.offsetHeight)
      } else {
        this.closeDropdowns()
      }
    }
  }

  onMouseLeave () {
    this.closeDropdowns()
  }

  setBackdrop (heightValue) {
    const backdropEl = this.querySelector(
      `[data-header-dropdown-el="backdrop"]`,
    )

    backdropEl.style.setProperty(
      '--Height',
      heightValue === 0 ? 0 : `calc(100% + ${heightValue}px)`,
    )
    backdropEl.setAttribute('aria-hidden', heightValue === 0)
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
